<!-- =========================================================================================
    File Name: MailItem.vue
    Description: Mail Item - Displays mail item
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="mail__mail-item sm:px-4 px-2 py-6" :class="{'mail__opened-mail': !mail.status === 'NEW'}">

        <!-- MAIL ROW 1 : META -->
        <div class="flex w-full">
<!--
            <vs-avatar class="sender__avatar flex-shrink-0 mr-3 border-2 border-solid border-white" :src="mail.img" size="40px"></vs-avatar>
-->

            <div class="flex w-full justify-between items-start">
                <div class="mail__details">

                    <h5 class="mb-1" :class="{'font-semibold': mail.status === 'NEW'}">ID: #{{ mail.id }} - {{ mail.authors }}</h5>

                    <span v-if="mail.subject">{{ mail.subject }}</span>

                    <div class="vx-col w-full">
                      <span class="mail__content break-words mt-8 mb-4" style="font-size: 12px"><b>Направление:</b> {{ mail.category.name }}</span>
                    </div>
                    <span v-else>(no subject)</span>
                </div>

                <!--<div class="mail-item__meta flex items-center">
                    <div class="email__labels hidden sm:flex items-center">
                        <div class="h-2 w-2 rounded-full mr-2" :class="'bg-' + labelColor(label)" v-for="(label, index) in mail.labels" :key="index"></div>
                    </div>
                    <span>{{ mail.created_at | date }}</span>
                </div>-->
            </div>
        </div>
        <!-- /MAIL ROW 1 -->
         <vs-chip :color="colorStatus(mail.status)">Статус заявка:&nbsp;{{ nameStatus(mail.status) }}</vs-chip>

        <vs-chip :color="colorStatus(mail.payment_status)">Статус оплаты:&nbsp;{{ nameStatusPayment(mail.payment_status) }}</vs-chip>
        <!-- MAIL ROW 2 : MSG & ACTIONS -->
        <div class="flex w-full">
            <div class="flex items-center ml-1">
                <vs-checkbox v-model="isSelectedMail" @click.stop class="vs-checkbox-small ml-0 mr-1"></vs-checkbox>
            </div>
            <div class="mail__message truncate ml-3">
                <span>{{ mail.email | filter_tags }}</span>
            </div>
        </div>
        <!-- /MAIL ROW 2 -->
    </div>
</template>

<script>
export default {
  props: {
    mail: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isSelectedMail: this.isSelected
    }
  },
  watch: {
    isSelected (value) {
      this.isSelectedMail = value
    },
    isSelectedMail (val) {
      val ? this.$emit('addToSelected', this.mail.id) : this.$emit('removeSelected', this.mail.id)
    }
  },
  computed: {
    labelColor () {
      return (label) => {
        const tags = this.$store.state.email.mailTags
        return tags.find((tag) => {
          return tag.value === label
        }).color
      }
    }
  },
  methods: {
    colorStatus (status) {
      switch (status) {
      case 'NEW':
        return 'primary'
      case 'SENT':
        return 'primary'
      case 'ACCEPTED':
        return 'success'
      case 'COMPLETED':
        return 'success'
      case 'PAID':
        return 'success'
      case 'RE_UPLOAD':
        return 'warning'
      case 'UNPAID':
        return 'warning'
      case 'NOT_ACCEPTED':
        return 'danger'
      case 'FAIL':
        return 'danger'
      }
    },
    nameStatus (status) {
      switch (status) {
      case 'NEW':
        return 'НОВЫЙ'
      case 'ACCEPTED':
        return 'ПРИНЯТЫЙ'
      case 'COMPLETED':
        return 'ЗАВЕРШЕННЫЙ'
      case 'NOT_ACCEPTED':
        return 'ОТМЕННЕННЫЙ'
      case 'RE_UPLOAD':
        return 'В повторном рассмотрении'
      case 'FAIL':
        return 'Тех. ошибки'
      }
    },
    nameStatusPayment (status) {
      switch (status) {
      case 'NEW':
        return 'Новый/Не оплаченный'
      case 'UNPAID':
        return 'Не оплаченный'
      case 'PAID':
        return 'Оплаченный'
      case 'SENT':
        return 'Счет отправлен'
      }
    },
    toggleIsStarred () {
      const payload = { mailId: this.mail.id, value: !this.mail.isStarred }
      this.$store.dispatch('email/toggleIsMailStarred', payload)
    }
  }
}

</script>

